import RecipeTeaser from 'js/pages/NutritionExplained/components/RecipeTeaser'
import React from 'react'
import PropTypes from 'prop-types'

export default function RecipeTeaserBlock(props) {
  return (
    <RecipeTeaser
      {...props}
      slug={false}
      sizes="(min-width: 900px) 900px, 100vw"
    />
  )
}

RecipeTeaserBlock.propTypes = {
  image: PropTypes.shape({}),
  intro: PropTypes.string,
  name: PropTypes.string,
  time: PropTypes.number,
  calories: PropTypes.number,
}
